import React from "react";

const CompletedSmall = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3578_7)">
      <rect x="4" y="4" width="16" height="16" rx="2" fill="#E4FFEC" />
    </g>
    <path
      d="M11.1108 12.9688L9.13755 10.9955C8.65143 10.5094 7.85074 10.5094 7.36459 10.9955C6.87847 11.4816 6.87847 12.2823 7.36459 12.7685L10.2243 15.6282C10.4531 15.857 10.7677 16 11.1107 16C11.4538 16 11.7684 15.857 11.9972 15.6282L17.4878 10.1376C17.9739 9.65143 17.9739 8.85074 17.4878 8.36459C17.0017 7.87847 16.201 7.87847 15.7149 8.36459L11.1108 12.9688Z"
      fill="#59C376"
    />
    <defs>
      <filter
        id="filter0_d_3578_7"
        x="0"
        y="0"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3578_7"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3578_7"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default CompletedSmall;
